module.exports = __webpack_public_path__ + "media/icons/rodzaj-paliwa-3695b02e.png";